// extracted by mini-css-extract-plugin
export var pageIndicator = "PageIndicator-module--pageIndicator--Qqhlj";
export var pageIndicatorActive = "PageIndicator-module--pageIndicatorActive--1He-d";